export class JobPriorityType {
    readonly grade: string;
    readonly id: number;
    readonly adminDescription: string;
    readonly recruiterDescription: string;
    readonly clientDescription: string;

    public isIn = (arr: { jobPriorityTypeId: number }[]): boolean => {
        arr = arr != null ? arr : [];
        return arr.findIndex(t => t.jobPriorityTypeId === this.id) >= 0;
    };

    private constructor(
        id: number,
        name: string,
        adminDescription: string,
        recruiterDescription: string,
        clientDescription: string
    ) {
        this.id = id;
        this.grade = name;
        this.adminDescription = adminDescription;
        this.recruiterDescription = recruiterDescription;
        this.clientDescription = clientDescription;
    }

    public static A = new JobPriorityType(
        1,
        "A",
        "Strong hiring conditions - Strong salary with favourable supply.",
        "Strong hiring conditions",
        "Strong hiring conditions - Strong salary with favourable supply."
    );
    public static B = new JobPriorityType(
        2,
        "B",
        "Adequate hiring conditions - Competitive salary with limited supply or demand.",
        "Adequate hiring conditions",
        "Adequate hiring conditions - Competitive salary with limited supply or demand."
    );
    public static C = new JobPriorityType(
        3,
        "C",
        "Challenging hiring conditions - Limiting salary with limited supply and high demand.",
        "Challenging hiring conditions",
        "Challenging hiring conditions - Limiting salary with limited supply and high demand."
    );
    public static D = new JobPriorityType(
        4,
        "D",
        "Difficult hiring conditions - Very limited salary with scarce supply and high demand.",
        "Difficult hiring conditions",
        "Difficult hiring conditions - Very limited salary with scarce supply and high demand. "
    );

    public static asArray = () => [
        JobPriorityType.A,
        JobPriorityType.B,
        JobPriorityType.C,
        JobPriorityType.D,
    ];

    public static fromId = (id: number) =>
        JobPriorityType.asArray().find(t => t.id === id);

    public static isSuccessFeeUniversal = (
        jobPriorityASuccessFeePercentage: number | undefined,
        jobPriorityBSuccessFeePercentage: number | undefined,
        jobPriorityCSuccessFeePercentage: number | undefined,
        jobPriorityDSuccessFeePercentage: number | undefined
    ) => typeof jobPriorityASuccessFeePercentage === "number" &&
            jobPriorityASuccessFeePercentage ===
                jobPriorityBSuccessFeePercentage &&
            jobPriorityBSuccessFeePercentage ===
                jobPriorityCSuccessFeePercentage &&
            jobPriorityCSuccessFeePercentage ===
                jobPriorityDSuccessFeePercentage;
}
